const extractErrorMessage = error =>
  (error?.err && error.err.hasOwnProperty('message') && error.err.message) || error?.message;

export { extractErrorMessage };
